import React from 'react';

const TermsCheckbox = ({ checked, onChange, className = '' }) => {
  return (
    <label className={`flex items-start gap-3 text-sm cursor-pointer ${className}`}>
      <input 
        type="checkbox" 
        name="terms-agree" 
        checked={checked}
        onChange={onChange}
        required
        className="mt-1 w-4 h-4 rounded border-[#333] bg-[#FFFFFF] text-[#2CA8A0] focus:ring-[#2CA8A0] focus:ring-offset-0 cursor-pointer"
        data-testid="terms-checkbox"
      />
      <span className="text-[#999] leading-relaxed">
        I am 18+ years old and I have read and agree to the{' '}
        <a href="/terms" target="_blank" rel="noopener noreferrer" className="text-[#2CA8A0] hover:underline">
          Terms & Conditions
        </a>{' '}
        and{' '}
        <a href="/privacy" target="_blank" rel="noopener noreferrer" className="text-[#2CA8A0] hover:underline">
          Privacy Policy
        </a>.
        I understand all services are for informational purposes only and do not constitute professional advice.
      </span>
    </label>
  );
};

export default TermsCheckbox;
